import { Instagram, Facebook, WhatsApp } from '@material-ui/icons';

export const SocialUrls = [
  {
    url: 'https://www.aparat.com/decooj',
    icon: <Facebook />,
  },
  {
    url: 'https://instagram.com/decooj.mag',
    icon: <Instagram />,
  },
  {
    url: 'https://wa.me/989056172800',
    icon: <WhatsApp />,
  },
];

export const forms = {
  registrationHeader: 'ثبت نام در دکوژ',
  loginHeader: 'ورود به حساب کاربری',
  email: {
    enter: 'ایمیل خود را وارد کنید',
    check: 'ایمیل نامعتبر است',
  },
  password: {
    enter: 'رمز عبور را وارد نمایید',
    check: 'رمز عبور هم خوانی ندارد',
    validation: 'رمز عبور باید حداقل 8 کاراکتر و شامل عدد و حروف باشد',
  },
  code: 'کد تایید را به درستی وارد کنید',
  existingAccount: 'در دکوژ حساب کاربری دارید؟ ورود',
  notRegistered: 'فروشگاه خودت را بساز، ثبت نام',
  emailPasswordHint:
    'لطفا برای ثبت نام ابتدا ایمیل خود به همراه یک رمز عبور دلخواد وارد کنید',
  validationHint:
    'یک کد فعال سازی به ایمیل شما ارسال شده است، لطفا ایمیل خود را بررسی کنید و درصورتی که در inbox شما نبود پوشه spam را بررسی کنید کد فعالسازی خود را در کادر زیر وارد نمایید',
  loginHint: 'لطفا ایمیل و رمز عبور  هنگام ثبت نام را وارد کنید',
  labels: {
    email: 'ایمیل',
    password: 'رمز عبور',
    password_confirmation: 'تکرار رمز عبور',
  },
  acceptTerms: {
    hint: 'تمامی قوانین سایت را می پذیرم ',
    error: 'پذیرفتن قوانین سایت الزامی است',
  },
  buttons: {
    registration: 'ثبت نام',
    resendCode: 'ارسال مجدد کد ',
    login: 'ورود',
    validation: 'ثبت کد تایید',
  },
};

export const MerchantProfile = {
  merchantForm: {
    name: 'نام',
    family: 'نام خانوادگی',
    birthday: 'تاریخ تولد',
    gender: 'جنسیت',
    nationalCode: 'کدملی',
    email: 'ایمیل',
    tel: 'شماره تلفن ثابت',
    address: 'آدرس',
    postalCode: 'کد پستی',
    phone: 'شماره تلفن همراه',
    province: 'انتخاب استان',
    city: 'انتخاب شهر',
    personalInfo: 'اطلاعات فردی',
    callInfo: 'اطلاعات تماس',
    saveChanges: 'ذخیره تغییرات',
    edit: 'ویرایش',
    profileImage: 'تصویر پروفایل',
    license: 'تصویر کارت ملی',
    hintProfileImage: 'بارگذاری تصویر پروفایل',
    hintLicense: 'بارگذاری تصویر کارت ملی',

    businessInfo: 'اطلاعات تجاری',
    storeStatus: 'وضعیت فروشگاه',
    inActive: 'غیرفعال',
    pending: 'در انتظار تایید',
    active: 'فعال',
    merchantCode: 'کد فروشنده',
    businessCode: 'کد اقتصادی',
    licenseImage: 'تصویر جواز',
    hintLicenseImage: 'بارگذاری جواز کسب و کار',
    merchantType: 'نوع فروشنده',
    businessName: 'نام فروشگاه',
    vatLicense: 'گواهی ارزش افزوده',
  },
  error: {
    name: 'نام خود را وارد کنید',
    family: 'نام خانوادگی خود را وارد کنید',
    birthday: ' تاریخ نولد خود را وارد کنید',
    gender: 'یک گزینه را انتخاب کنید',
    nationalCode: 'کد ملی خود را وارد کنید',
    nationalCodeLength: 'کد ملی باید شامل ده رقم باشد',
    email: 'ایمیل خود را وارد کنید',
    tel: 'شماره تلفن خود را وارد کنید',
    telLength: 'شماره تلفن باید شامل هشت رقم باشد',
    address: 'آدرس خود را به صورت دقیق وارد کنید',
    postalCode: 'کد پستی را وارد کنید',
    phone: 'شماره تلفن همراه خود را وارد کنید',
    phoneLength: 'شماره موبایل باید شامل یازده رقم باشد',
    province: ' استان خود را انتخاب کنید',
    city: 'شهر خود را انتخاب کنید',

    storeStatus: '',
    merchantCode: 'کد فروشنده را وارد کنید',
    businessCode: 'کد اقتصادی را وارد کنید',
    merchantType: 'نوع فروشنده را انتخاب کنید',
    storeName: 'نام فروشگاه را وارد کنید',
    businessName: 'نام تجاری را وارد کنید',
    vatLicense: 'یک گزینه را انتخاب کنید',
  },
};

export const merchantDetail = {
  header: {
    profile: 'پروفایل',
    storeSelectLabel: 'تغییر وضعیت فروشگاه',
    title: 'مدیریت پیشه وران',
    selectLabel: 'تغییر وضعیت پروفایل پیشه ور',
    pending: 'در انتظار تایید',
    active: ' تایید شده',
    inActive: 'تایید نشده',
    remove: 'حذف',
    back: 'برگشت',
    store: 'فروشگاه',
    confirm: 'تایید',
  },
  toasts: {
    error: ' پیشه ور به حالت تایید نشده درآمد',
    warn: ' پیشه ور به حالت در  انتظار تایید در آمد',
    success: ' پیشه ور با موفقیت تایید شد',
  },
};
export const merchantStore = {
  managment: 'مدیریت فروشگاه',
  name: 'نام فروشگاه / برند',
  about: 'درباره فروشگاه',
  type: 'نوع فروشگاه',
  tag: 'تگ های فروشگاه',
  callInfo: 'اطلاعات تماس فروشگاه',
  tel: 'تلفن',
  address: 'آدرس',
  image: 'بارگذاری  تصاویر فروشگاه',
  logo: 'لوگو',
  catalog: 'کاتالوگ / رزومه',
  gallery: 'گالری فروشگاه',
  edit: 'ویرایش',
  saveChanges: 'ذخیره تغییرات',
  error: {
    name: 'نام فروشگاه یا برندرا وارد کنید',
    about: 'توضیحات مربوط به فروشگاه را به صورت کامل بیان کنید',
    tel: 'تلفن یازده رقمی فروشگاه را وارد کنید',
    telLength: 'شماره تلفن باید شامل یازده رقم باشد',
    address: 'آدرس فروشگاه را وارد کنید',
  },
};

export const LandingForm = {
  name: 'نام خود را وارد کنید',
  family: 'نام خانوادگی خود را وارد کنید',
  national: 'کد ملی خود را وارد کنید',
  nationalLen: 'کد ملی باید شامل 10 رقم باشد',
  store_name: 'نام فروشگاه خود را وارد کنید',
  mobile: 'شماره تلفن همراه خود را وارد کنید',
  mobileLength: 'شماره موبایل باید شامل 11 رقم باشد',
  email: forms.email,
};

// options
export const GenderOpt = [
  { label: 'مرد', value: '1' },
  { label: 'زن', value: '2' },
];

export const TypeOpt = [
  { label: 'حقیقی', value: '0' },
  { label: 'حقوقی', value: '1' },
];

export const LicenceOpt = [
  { label: 'دارم', value: '0' },
  { label: 'ندارم', value: '1' },
];

export const ProductTypeOpt = [
  { label: 'عادی', value: '1' },
  { label: 'سفارشی', value: '2' },
];

export const ProductStatusOpt = [
  {
    label: 'عدم انتشار',
    value: 0,
  },
  {
    label: 'پیش نویس',
    value: 1,
  },
  {
    label: 'انتشار',
    value: 2,
  },
];

export const StatusOpt = [
  { value: '0', label: 'غیرفعال', color: '#e4464b' },
  { value: '1', label: 'در انتظار تایید', color: '#f99300' },
  { value: '2', label: 'فعال', color: '#44a570' },
];

export const ProductSortOpt = [
  {
    value: 'newest',
    label: 'جدید ترین',
  },
  {
    value: 'expensivest',
    label: 'گران ترین',
  },
  {
    value: 'cheapest',
    label: 'ارزان ترین',
  },
  // {
  //   value: 'date:asc',
  //   label: 'پرفروش ترین',
  // },
];
